import Router from 'next/router';
import { INTERNAL_ROUTES } from '@helpers/route';
import { useCallback, useState, SyntheticEvent, useEffect } from 'react';
import { useLayoutContext } from '@views/layouts';
import { useAlert } from 'react-alert';
import useLocalStorage from '@views/layouts/hooks/use-local-storage';

const KEY = 'vpp_widget_navigation_in_prop';

export function useData() {
  const { authenticated } = useLayoutContext();
  const alert = useAlert();
  const [inProp, setInProp] = useLocalStorage(KEY, 'out');

  const handleRouteInterest = useCallback(
    async (event: SyntheticEvent) => {
      event.preventDefault();
      if (!authenticated) {
        alert.show('Bạn cần đăng nhập để thực hiện tính năng này');
        return;
      }

      Router.push(INTERNAL_ROUTES.INTEREST_PRODUCT);
    },
    [authenticated, alert]
  );

  const handleToggleInProp = useCallback(
    async (event: SyntheticEvent) => {
      event.preventDefault();
      setInProp(inProp === 'out' ? 'in' : 'out');
    },
    [inProp, setInProp]
  );

  return {
    inProp,
    handleRouteInterest,
    handleToggleInProp,
  };
}
